type Props = {
  className?: string;
}

const Breadcrumb: React.ReactFCWithChildren<Props> = ({ className = '', children }) => {
  return (
    <ol className={`breadcrumb tw-overflow-x-auto ${className}`}>
      {children}
    </ol>
  )
}

export default Breadcrumb
